import * as React from 'react';
import useCoachFilterLookupData from '@nkr/store/microsites/hooks/use-coach-filter-lookup-data';
import { Button, FormControl, Well } from 'react-bootstrap';
import { filterBarStyles } from './styles';

export interface ICoachFilters {
    organType: number;
    languagePreference: number;
    messageStatus: number;
    centerId: number;
    coachStatus: number;
    status: number;
    search: string;
    showHidden: boolean;
}

export const defaultCoachFilters: ICoachFilters = {
    organType: -1,
    languagePreference: -1,
    messageStatus: -1,
    centerId: 0,
    coachStatus: 0,
    status: -1,
    search: '',
    showHidden: false
};

interface IProps {
    filters: ICoachFilters;
    onChange: (filters: ICoachFilters) => void;
    onReset: () => void;
}

const ControlWrapper = ({ label, children }: { label: string; children: React.ReactNode }) => (
    <div style={filterBarStyles.controlWrapper}>
        <div style={filterBarStyles.controlLabel}>{label}</div>
        <div>{children}</div>
    </div>
);

const CoachFilterBar: React.FC<IProps> = ({ filters, onChange, onReset }) => {
    const { micrositeTypeList, languageList, commStatusList, coachStatusList, statusList, centerList } = useCoachFilterLookupData();

    const handle = (field: keyof ICoachFilters, value: any) => onChange({ ...filters, [field]: value });

    return (
        <Well bsSize='sm' style={filterBarStyles.well}>
            <div style={filterBarStyles.row}>
                <ControlWrapper label="Organ Type:">
                    <FormControl componentClass='select' value={filters.organType} onChange={e => handle('organType', parseInt((e as any).currentTarget.value))}>
                        <option value={-1}>- ALL -</option>
                        {micrositeTypeList.map((item, i) => <option key={i} value={item.id}>{item.description}</option>)}
                    </FormControl>
                </ControlWrapper>

                <ControlWrapper label="Language Preference:">
                    <FormControl componentClass='select' value={filters.languagePreference} onChange={e => handle('languagePreference', parseInt((e as any).currentTarget.value))}>
                        <option value={-1}>- ALL -</option>
                        {languageList.map((item, i) => <option key={i} value={item.id}>{item.description}</option>)}
                    </FormControl>
                </ControlWrapper>

                <ControlWrapper label="Message Status:">
                    <FormControl componentClass='select' value={filters.messageStatus} onChange={e => handle('messageStatus', parseInt((e as any).currentTarget.value))}>
                        <option value={-1}>- ALL -</option>
                        {commStatusList.map((item, i) => <option key={i} value={item.id}>{item.description}</option>)}
                    </FormControl>
                </ControlWrapper>

                {centerList.length > 1 && (
                    <ControlWrapper label="Center:">
                        <FormControl componentClass='select' value={filters.centerId} onChange={e => handle('centerId', parseInt((e as any).currentTarget.value))}>
                            <option value={0}>- ALL -</option>
                            {centerList.map((c, i) => <option key={i} value={c.id}>{c.alias}</option>)}
                        </FormControl>
                    </ControlWrapper>
                )}

                <ControlWrapper label="Coach Status:">
                    <FormControl componentClass='select' value={filters.coachStatus} onChange={e => handle('coachStatus', parseInt((e as any).currentTarget.value))}>
                        <option value={0}>- ALL -</option>
                        {coachStatusList.filter(f => f.isActive).map((item, i) => <option key={i} value={item.id}>{item.description}</option>)}
                    </FormControl>
                </ControlWrapper>

                <ControlWrapper label="Status:">
                    <FormControl componentClass='select' value={filters.status} onChange={e => handle('status', parseInt((e as any).currentTarget.value))}>
                        <option value={-1}>- ALL -</option>
                        {statusList.map((item, i) => <option key={i} value={item.id}>{item.description}</option>)}
                    </FormControl>
                </ControlWrapper>

                <ControlWrapper label="Search:">
                    <FormControl
                        style={filterBarStyles.searchInput}
                        value={filters.search}
                        placeholder='Search...'
                        onChange={e => handle('search', (e as any).currentTarget.value)}
                    />
                </ControlWrapper>

                <div style={filterBarStyles.buttonRow}>
                    <Button bsStyle={filters.showHidden ? 'primary' : 'default'} style={filterBarStyles.showHiddenButton} onClick={() => handle('showHidden', !filters.showHidden)}>
                        {filters.showHidden ? 'Suppress Hidden' : 'Show Hidden'}
                    </Button>
                    <Button bsStyle='primary' onClick={onReset}>Reset Filters</Button>
                </div>
            </div>
        </Well>
    );
};

export default CoachFilterBar;
